import { render, staticRenderFns } from "./ConfirmWindow.vue?vue&type=template&id=88d62f7a&scoped=true"
import script from "./ConfirmWindow.vue?vue&type=script&lang=js"
export * from "./ConfirmWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d62f7a",
  null
  
)

export default component.exports